export default __webpack_public_path__ + "568eb82c4bf67b3e16d68699c20c23bd.png";